import $ from "jquery";

const checkboxInput = $('.form-checkbox').find('input');
const displayedBlockBillingAddress = $('.billing-address');

export const paymentPageFormHandlers = () => {
    checkboxInput.on('click', function () {
        let checkboxChecked = $(this).is(':checked');

        if (checkboxChecked) {
            displayedBlockBillingAddress.hide();
        } else {
            displayedBlockBillingAddress.show();
        }
    });
};
